// Form + footer helpers for the russia-carriers admin surface (#1166).
// Mirrors `RoadOptionForm` so any future tweak in the shared editor
// scaffolding (`EditorGuardContext`, `EditorFooter`) propagates to both
// catalogs the same way. Contacts is intentionally a multiline textarea
// (free-form by spec §4 — no structured sub-fields in v1).

import { useTranslation } from 'react-i18next';
import { Button, Input, Textarea, useEditorGuard } from '../../../ui/index.js';

export function RussiaCarrierForm({
  name,
  contacts,
  active,
  readOnly = false,
  onChangeName,
  onChangeContacts,
}: {
  name: string;
  contacts: string;
  active: boolean;
  readOnly?: boolean;
  onChangeName: (value: string) => void;
  onChangeContacts: (value: string) => void;
}) {
  const { t } = useTranslation('russiaCarriers');
  const nameInvalid = name.length > 0 && name.trim().length === 0;
  const contactsInvalid = contacts.length > 0 && contacts.trim().length === 0;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 5, fontSize: 12 }}>
        <span style={{ color: 'var(--fg-3)' }}>{t('fields.name')} *</span>
        <Input value={name} onChange={onChangeName} readOnly={readOnly} maxLength={200} />
        {nameInvalid && (
          <span style={{ color: 'var(--status-error-fg)' }}>{t('errors.nameRequired')}</span>
        )}
      </label>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 5, fontSize: 12 }}>
        <span style={{ color: 'var(--fg-3)' }}>{t('fields.contacts')} *</span>
        <Textarea value={contacts} onChange={onChangeContacts} readOnly={readOnly} rows={5} />
        <span style={{ color: contactsInvalid ? 'var(--status-error-fg)' : 'var(--fg-3)' }}>
          {contactsInvalid ? t('errors.contactsRequired') : t('fields.contactsHelp')}
        </span>
      </label>
      {!active && (
        <span style={{ color: 'var(--fg-3)', fontSize: 12 }}>{t('hints.archivedRow')}</span>
      )}
    </div>
  );
}

export function EditorFooter({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        marginTop: 12,
        marginLeft: -16,
        marginRight: -16,
        marginBottom: -16,
        padding: '12px 16px',
        borderTop: '1px solid var(--border-2)',
        display: 'flex',
        gap: 8,
        justifyContent: 'flex-end',
      }}
    >
      {children}
    </div>
  );
}

export function CancelButton({ onClose, label }: { onClose: () => void; label: string }) {
  const { confirmDestructive } = useEditorGuard();
  return (
    <Button kind="ghost" onClick={() => confirmDestructive(onClose)}>
      {label}
    </Button>
  );
}
